import { render, staticRenderFns } from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=template&id=e16e8506&"
import script from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=script&lang=js&"
export * from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports